module.exports = __webpack_public_path__ + "img/back.b0ef3849.svg";